import { observable, action, makeObservable } from 'mobx';
import { persist } from 'mobx-persist';

import { HydratedStore, User } from 'src/utils/classes';

const AUTH_STORAGE_KEY = 'd4urx_auth';

class LoginStore extends HydratedStore {
  constructor() {
    super('LoginStore_v2'); // Storage ID

    makeObservable(this);
  }

  @persist @observable loginEmail: string = '';
  @observable loginPassword: string = '';
  @persist('object', User) @observable user?: User;
  @persist @observable userToken: string = '';

  @action setLoginEmail = (value: string) => this.loginEmail = value;
  @action setLoginPassword = (value: string) => this.loginPassword = value;

  @action setUser = (value?: any) => {
    this.user = value ? new User(value) : undefined;
    if (this.user) {
      try {
        // userToken is set just before setUser is called during login, so this captures both
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({
          user: { credentials: this.user.credentials, token: this.user.token },
          userToken: this.userToken || this.user.token,
          loginEmail: this.loginEmail,
        }));
      } catch (e) {
        console.error('[LoginStore] failed to persist auth', e);
      }
    } else {
      localStorage.removeItem(AUTH_STORAGE_KEY);
    }
  };

  @action setUserToken = (value: string) => {
    this.userToken = value;
  };

  @action doLogout = () => {
    this.userToken = '';
    this.user = undefined;
    this.loginPassword = '';
    localStorage.removeItem(AUTH_STORAGE_KEY);
  };

  @action restoreFromStorage = () => {
    try {
      const stored = localStorage.getItem(AUTH_STORAGE_KEY);
      if (stored && !this.user) {
        const data = JSON.parse(stored);
        if (data?.user?.credentials && data?.userToken) {
          this.user = new User(data.user);
          this.userToken = data.userToken;
          this.loginEmail = data.loginEmail || '';
        }
      }
    } catch (e) {
      console.error('[LoginStore] failed to restore auth from storage', e);
      localStorage.removeItem(AUTH_STORAGE_KEY);
    }
  };
}

export default new LoginStore();
